class HeaderController {
  constructor() {
  }
}

export default HeaderController;
